import React from "react";
import { useNavigate } from "react-router-dom";

const PrivacyPolicy = () => {
  const navigate = useNavigate();
  return (
    <div id="layout">
      <div className="TermsAndConditions_header">
        <h1 onClick={() => navigate(-1)}>
          <svg
            className="me-2"
            width="15"
            height="15"
            viewBox="0 0 13 13"
            fill="none"
          >
            <rect
              width="13"
              height="13"
              transform="matrix(-1 0 0 1 13 0)"
              fill="url(#pattern0)"
            />
            <defs>
              <pattern
                id="pattern0"
                patternContentUnits="objectBoundingBox"
                width="1"
                height="1"
              >
                <use
                  xlinkHref="#image0_1916_184"
                  transform="scale(0.00390625)"
                />
              </pattern>
              <image
                id="image0_1916_184"
                width="256"
                height="256"
                xlinkHref="data:image/png;base64,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"
              />
            </defs>
          </svg>
          Privacy Policy
        </h1>
      </div>
      <div className="TermsAndConditions_content">
        <div>
          <p>
            DRCFO Advisory Services Pvt. Ltd. (hereinafter the “Company”, “We”,
            “Us”, and “Our” interchangeably) is the owner of the Website
            www.myhealthvaults .in and the Mobile Application (hereinafter
            “Application” which includes the Website, Software program, data and
            documentation related thereto), and provides services related to
            health data management and online appointments with healthcare
            professional and other related services (collectively referred to as
            “Service/Services”) for integrated health care management for
            patients. This Privacy Policy must be read in conjunction with the
            Terms of Use. Any capitalized term used but not defined in this
            Privacy Policy shall have the meaning attributed to it in our Terms
            of Use. We are committed to Your privacy. This privacy policy
            ("Privacy Policy") applies to Your use of and access to the Services
            and the collection, use, storage, sharing, processing, disclosure,
            and transfer of Your Information including Your Personal Information
            when You access and/or use the Services. You are advised to
            carefully read this Privacy Policy before using or accessing any of
            Our Services. Our Privacy Policy is applicable to every User who
            accesses our Application and/or uses Our Services (referred to as
            “You”, “User” or “Your” as applicable) from any device.
          </p>
        </div>
        <div>
          <h2>1. CONSENT</h2>
          <p>
            1.1 By using the Services or by otherwise voluntarily providing us
            Your information, You will be deemed to have read, understood, and
            agreed to the practices and policies outlined in this Privacy Policy
            and agree to be bound by the same. <br /> 1.2 You acknowledge that
            You are providing Your Personal Information out of Your free will.{" "}
            <br /> 1.3 You hereby consent to Our collection, use and sharing,
            storage, processing, and disclosure of Your information as described
            in this Privacy Policy. <br /> 1.4 If You use the services on behalf
            of someone else, You represent that You are authorized on behalf of
            such User by such User to accept this Privacy Policy, and consent to
            Our collection, use, and disclosure of such information as described
            in this Privacy Policy. <br /> 1.5 We reserve the right to amend the
            portions of terms of this Privacy Policy by way of modification,
            addition, or deletion, at Our sole discretion, at any time. The last
            updated date on the top of the page indicates when the Privacy
            Policy was last updated. If you do not agree to the amendments in
            this Privacy Policy at any time, do not use any of the Services any
            further. <br /> 1.6 You have the option not to provide Us the
            Personal Information. You also have the option to withdraw Your
            consent at any point. If You do not provide us with Your Personal
            Information or if You withdraw the consent at any point in time, You
            shall not be able to access and use Our Services.
          </p>
        </div>
        <div>
          <h2>2. SCOPE</h2>
          <p>
            This Privacy Policy states the type of information collected from
            the Users, the purpose, means, and modes of collection, usage,
            processing, retention, and destruction of such information; and how
            and to whom We will disclose such information.
          </p>
        </div>
        <div>
          <h2>3. COLLECTION OF PERSONAL INFORMATION</h2>
          <p>
            3.1 We may ask You to voluntarily provide Us with certain
            information that personally identifies You or could be used to
            personally identify You. You hereby consent to the collection of
            such Information by Us. <br /> 3.2 Without prejudice to the
            generality of the above, Personal Information collected by Us for
            Your registration to Our Services may include (but is not limited
            to) the following: <br /> i. Name <br /> ii. Date of Birth <br />{" "}
            iii. Email address <br /> iv. Phone Number <br /> v. Gender <br />{" "}
            vi. Location <br /> vii. Pin code <br /> 3.3 Without prejudice, to
            make full use of Our Services and best meet Your needs, Information
            collected by Us may include (but is not limited to) the following:
            <br />
            i. data regarding your usage of the services and history of the
            appointments made by or with You through the use of Services
            <br /> ii. sensitive financial information such as bank accounts,
            credit, and debit card details, or other payment instrument details;
            <br /> iii. biometric information <br /> iv. medical records and
            history <br /> v. physical, physiological, and mental health
            conditions <br /> vi. other information that You voluntarily choose
            to provide to Us <br /> 3.4 We shall be free to use, collect and
            disclose information that is freely available in the public domain
            without your consent. <br /> 3.5 We may also seek permission to use
            the camera, microphone, and phonebook/contact data at points where
            required. <br /> 3.6 We may also collect information other than
            Personal Information from You when You visit and /or use the
            Application. Such information may be stored in server logs. Such
            Non-Personal Information would not assist us to identify You
            personally. Such Non-Personal Information may include
            <br /> i. Your usage details such as time, frequency, duration and
            pattern of use, features used and the amount of storage used, <br />{" "}
            ii. Master and transaction data and other data stored in Your user
            account, <br /> iii. Internet Protocol address, browser type,
            browser language, referring URL, files accessed, errors generated,
            time zone, operating system, and other visitor details collected in
            Our log files.
          </p>
        </div>
        <div>
          <h2>4. METHODS TO COLLECT INFORMATION</h2>
          <p>
            4.1 The methods by which We collect Your Information include (but
            are not limited to) the following: <br /> i. when You register on
            Our Application;
            <br /> ii. when You create a profile on Our Application or as part
            of Services; <br /> iii. when You provide Your Information to us;{" "}
            <br /> iv. when You use the features on Our Application and/or when
            You use Services; <br /> v. when You access Applications or
            Services; <br /> vi. by use of cookies
          </p>
        </div>
        <div>
          <h2>5. USE OF THE COLLECTED INFORMATION</h2>
          <p>
            5.1 We collect Your Information for various purposes, an indicative
            non-limiting list of such purposes is mentioned below:
            <br /> i. in order to enable You to use the Application and utilize
            the Services. For instance, you may provide Your health-related
            information on the Website in order to consult privately with a
            Practitioner, or You may provide Your financial information in order
            to process a payment which You need to make on the Application;
            <br /> ii. to respond to Your inquiries; <br /> iii. to provide You
            with information about products and services available on the
            Application; <br /> iv. to personalize Your experience on the
            Application; <br /> v. to help You address Your problems incurred on
            the Application including addressing any technical problems; <br />{" "}
            vi. for proper administering of the Application; <br /> vii. to
            conduct internal reviews and data analysis for the Application
            (e.g., to determine the number of visitors to specific pages within
            the Website); <br /> viii. to improve the services, content, and
            advertising on the Application; <br /> ix. to protect the integrity
            of the Application;
            <br /> x. to respond to judicial process and provide information to
            law enforcement agencies or in connection with an investigation on
            matters related to public safety, as permitted by law; <br /> xi. to
            conduct analytical studies on various aspects including User
            behavior, User preferences, etc; <br /> xii. analyzing anonymized
            practice information for commercial use; <br /> xiii. processing
            payment instructions including those through independent third-party
            service providers such as payment gateways, banking, and financial
            institutions, pre-paid instrument and wallet providers for the
            processing of payment transactions or deferral of payment
            facilities; <br /> xiv. analyzing software usage patterns for
            improving the utility of Our Services;
            <br /> xv. for communication purposes so as to provide You with a
            better way of booking appointments and for obtaining feedback in
            relation to the Practitioners and their practice;
            <br /> xvi. debugging customer support-related issues;
            <br /> xvii. for the purpose of contacting You to complete any
            transaction if You do not complete a transaction after having
            provided Us with Your contact information in the course of
            completing such steps that are designed for the completion of the
            transaction; <br /> xviii. to make disclosures as may be required
            under applicable law.
          </p>
        </div>
        <div>
          <h2>6. ACCURACY AND UPDATION OF YOUR INFORMATION</h2>
          <p>
            6.1 You are responsible for maintaining the accuracy of the
            information You submit to Us, such as Your contact information
            provided as part of account registration. <br /> 6.2 If your
            Personal Information changes, You may correct, delete inaccuracies,
            or amend information by making the change in Your profile and
            informing us at the email provided below or using the Contact Us
            option. <br />
            6.3 We will make good faith efforts to make requested changes in Our
            then active databases as soon as reasonably practicable. <br />
            6.4 If You provide any information that is untrue, inaccurate, out
            of date, or incomplete (or becomes untrue, inaccurate, out of date,
            or incomplete), or We have reasonable grounds to suspect that the
            information provided by You is untrue, inaccurate, out of date or
            incomplete, We may, at Our sole discretion, suspend Your Account
            with Us.
          </p>
        </div>
        <div>
          <h2>7. PROTECTION OF YOUR INFORMATION</h2>
          <p>
            7.1 The security of Your Information is important to Us. We have
            adopted reasonable security practices and procedures to ensure that
            Your Information collected is secure. You agree that such measures
            are secure and adequate. We restrict access to Your Personal
            Information to Us and Our employees, agents, and third-party service
            providers who need to know such Information for your access and use
            of Our Service and provided that such entities agree to abide by
            this Privacy Policy.
            <br /> 7.2 While We will endeavor to take all reasonable and
            appropriate steps to keep secure any information which We hold about
            You and prevent unauthorized access, You acknowledge that the
            internet is not 100% secure and that We cannot provide any absolute
            assurance regarding the security of Your Information. We will not be
            liable in any way in relation to any breach of security or
            unintended loss or disclosure of information caused by Us in
            relation to Your Information. <br /> 7.3 Due to the communications
            standards on the Internet, when a User visits the Application and/or
            Services, We automatically receive the URL of the site from which
            anyone visits. We also receive the Internet Protocol (IP) address of
            each User’s device/server, User’s computer operating system and type
            of web browser the User is using, email patterns, as well as the
            name of the User’s ISP. This information is used to analyze overall
            trends to help Us improve its Service. The linkage between the
            User’s IP address and the User’s Personal Information is not shared
            with or disclosed to third parties. <br /> 7.4 Notwithstanding the
            above, We may share and/or disclose some of the aggregate findings
            in anonymized form (that cannot be identified personally) with
            advertisers, sponsors, investors, strategic partners, and others in
            order to help grow Our business.
          </p>
        </div>
        <div>
          <h2>8. YOUR FINANCIAL INFORMATION</h2>
          <p>
            We may require the User to pay with a credit card, wire transfer,
            debit card, or cheque for Services for which subscription amount(s)
            is/are payable. We will collect such User’s credit card number
            and/or other financial institution information such as bank account
            numbers and will use that information for the billing and payment
            processes, including but not limited to the use and disclosure of
            such credit card number and information to third parties as
            necessary to complete such billing operation. Verification of credit
            information, however, is accomplished solely by the User through the
            authentication process. Users’ credit card/debit card details are
            transacted upon secure sites of approved payment gateways which are
            digitally under encryption, thereby providing the highest possible
            degree of care as per current technology. However, We provide you an
            option not to save your payment details. User is advised, however,
            that internet technology is not completely safe and User should
            exercise discretion on using the same.
          </p>
        </div>
        <div>
          <h2>9. SHARING AND TRANSFER OF YOUR INFORMATION</h2>
          <p>
            9.1 We may exchange, transfer, share, part with all or any of Your
            Information, across borders and from India to any other country
            across the world with Our agents / third-party service providers,
            banks, and financial institutions for the purposes specified under
            this Privacy Policy or as may be required by applicable law or in
            case of sale, acquisition, merger or bankruptcy involving Us. <br />{" "}
            9.2 You acknowledge that some countries where We may transfer Your
            Information may not have data protection laws which are as stringent
            as the laws of India. <br />
            9.3 You acknowledge that it is adequate that when We transfer Your
            Information to any other entity within or outside India, We will
            place contractual obligations on the transferee which will oblige
            the transferee to adhere to the provisions of this Privacy Policy.
          </p>
        </div>
        <div>
          <h2>10. RETENTION OF YOUR INFORMATION</h2>
          <p>
            10.1 We will retain your information for as long as your account
            with the Services is active and as needed to provide You the
            Services. <br />
            10.2 We shall not retain such information for longer than is
            required for the purposes for which the information may lawfully be
            used or is otherwise required under any other law for the time being
            in force. <br />
            10.3 After a period of time, your data may be anonymized and
            aggregated, and then may be held by us as long as necessary for us
            to provide our Services effectively, but our use of the anonymized
            data will be solely for analytic purposes.
            <br />
            10.4 Please note that your withdrawal of consent or cancellation of
            account may result in Us being unable to provide you with Our
            Services or to terminate any existing relationship We may have with
            you.
          </p>
        </div>
        <div>
          <h2>11. CHILDREN'S AND MINOR'S PRIVACY</h2>
          <p>
            We strongly encourage parents and guardians to supervise the online
            activities of their minor children and consider using parental
            control tools available from online services and software
            manufacturers to help provide a child-friendly online environment.
            These tools also can prevent minors from disclosing their name,
            address, and other Personal Information online without parental
            permission. Although Our Services are not intended for use by
            minors, if You are a minor, You may use Our Application and Services
            only with the involvement of a parent or guardian and through a
            Parent controlled Account.
          </p>
        </div>
        <div>
          <h2>12. OPT OUT</h2>
          <p>
            If you wish to opt-out of receiving non-essential communications
            such as promotional and marketing-related information regarding the
            Services, please send us an email at the email provided below.{" "}
            <br /> We reserve the right to continue to keep a copy of any of
            your Personal Information if required by law. We may use any
            aggregated/anonymized data derived from your Account, in a matter
            which shall not infringe upon your privacy.
          </p>
        </div>
        <div>
          <h2>13. NO SPAM</h2>
          <p>
            We maintain a strict "No-Spam" policy, which means that We do not
            intend to sell, rent, or otherwise give your e-mail address to a
            third party without your consent.
          </p>
        </div>
        <div>
          <h2>14. COOKIES</h2>
          <p>
            We use Cookies and similar tracking technologies (For example, Web
            beacons, Pixels, Software Development Kits (SDKs), etc) to track the
            activity on Our Service and store certain information. Some of these
            cookies are essential for Us to provide You with Our Service. We or
            our third-party service providers may use cookies, mobile app
            analytics, and similar technologies to track visitor activity and
            collect data while You use/access Our Service. We may combine this
            data with other Personal information We have collected from the
            User. “Cookies” means small pieces of information used to store on
            web browsers that the Website can retrieve at a later time. Cookies
            are used to receive and store identifiers and other information on
            computers, phones, and other devices. Cookies include other
            technologies, including data that we store on Your web browser or
            device, identifiers associated with Your device, and other software,
            which are used for similar purposes. Cookies can be "Persistent" or
            "Session" Cookies. Persistent Cookies remain on your device when You
            go offline, while Session Cookies are deleted as soon as You close
            your web browser. You can change cookie settings in the help section
            of Your browser. You should be aware that the deactivation of
            cookies can influence Your experience of Our Service.
          </p>
        </div>
        <div>
          <h2>15. LINKS</h2>
          <p>
            Our Service may contain links to other websites that are not
            operated by Us. If You click on a Third-party link, You will be
            directed to that third party's website and/or mobile application or
            similar service. We strongly advise You to review the Terms and/or
            Privacy Policy and/or supplementary rules/guidelines of every
            website/mobile application You visit. We have no control over and
            assume no responsibility for the content, privacy policies, or
            practices of any third party sites or services. You further
            acknowledge and agree that We shall not be responsible or liable,
            directly or indirectly, for any damage or loss caused or alleged to
            be caused by or in connection with the use of or reliance on any
            such content, goods, or service available on or through any such
            websites or services.
          </p>
        </div>
        <div>
          <h2>16. COMPLIANCE WITH DATA PROTECTION LAWS</h2>
          <p>
            The Service accessed and used may be regulated by the applicable
            local laws and regulations on the protection of natural persons with
            regard to the collection, use, storage and processing of personal
            data and on the free movement of such data. You may reach out to Us
            at the email provided in Grievance Redressal Mechanism with the
            subject line “Data Protection compliance”. We respond to all
            requests We receive from individuals wishing to exercise their data
            protection rights in accordance with applicable data protection laws
            of India.
          </p>
        </div>
        <div>
          <h2>17. CHANGES TO PRIVACY POLICY</h2>
          <p>
            We may update Our Privacy Policy from time to time. We will notify
            You of any updation by posting the new Privacy Policy on this page
            and update the "Last updated Notice” date at the top of this Privacy
            Policy. You are advised to review this Privacy Policy periodically
            for any changes. Changes to this Privacy Policy are effective when
            they are posted on this page.
          </p>
        </div>
        <div>
          <h2>18. GRIEVANCE REDRESSAL MECHANISM</h2>
          <p>
            To report any grievance with respect to the Application or Our
            Services, including any discrepancies and grievances with respect to
            the processing of information, you can contact our Grievance Officer
            at:
            <br /> Name: CA Akhil Kumar <br />
            Address: C 5, 2nd Floor K K Apartment Opposite Narmada Bhawan (Near
            Ganna Sansthan) Dalibagh – Lucknow Pin -226001 <br />
            Phone: 91-94150-20199 <br />
            Email: akhil@drcfo.in
          </p>
        </div>
        <div>
          <h2>19. CONTACT INFORMATION</h2>
          <p>
            If you have any questions concerning the Company, the Application,
            the Terms, this Agreement, the Services, or anything related to any
            of the foregoing, or you wish to give your comments/feedback, You
            can reach us at the following email address mentioned below or using
            the Contact Us option in the Application. Unless otherwise specified
            herein, all notices or other communications under or in connection
            with this Agreement shall be given in writing and may be sent by
            personal delivery or post acknowledgment due or courier (with POD)
            or E-mail as mentioned below. Any such notice or other communication
            will be deemed to be effective if sent by personal delivery, (when
            delivered) if sent by registered post (ack due) (on actual receipt),
            and if sent by courier (on actual receipt), and if sent by E-mail,
            (on receipt of confirmation to the correct Email id). <br />
            Name: CA Akhil Kumar <br />
            Designation: CEO <br />
            Address: C 5, 2nd Floor K K Apartment Opposite Narmada Bhawan (Near
            Ganna Sansthan) Dalibagh – Lucknow Pin -226001 <br />
            Email ID: akhil@drcfo.in <br />
            [AK1]Not applicable
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
